function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.72506 14.5H14.2751C15.5584 14.5 16.3584 13.1083 15.7167 12L9.44173 1.15834C8.80006 0.0500041 7.20006 0.0500041 6.55839 1.15834L0.283394 12C-0.358273 13.1083 0.441727 14.5 1.72506 14.5ZM8.00006 8.66667C7.54173 8.66667 7.16673 8.29167 7.16673 7.83334V6.16667C7.16673 5.70834 7.54173 5.33334 8.00006 5.33334C8.45839 5.33334 8.83339 5.70834 8.83339 6.16667V7.83334C8.83339 8.29167 8.45839 8.66667 8.00006 8.66667ZM8.83339 12H7.16673V10.3333H8.83339V12Z",
  fill: "#F59E0B"
});

var SvgWarningIconOrange = function SvgWarningIconOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningIconOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning_icon_orange.8f18167a.svg";
export { ForwardRef as ReactComponent };